import { h, Host } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import isNull from 'lodash/isNull';
import { PRIMARY_BUTTONS, APC_PRIMARY_BUTTONS, SECONDARY_BUTTONS, EApcButtonType, EAvailabilityType, EQdsButtonImportance, BUTTON_TYPES, applyPriceTemplate, findProductFeedMinimalPrice, weeePricesToTextArray, format, exitToSchneiderEvent, send, CheckoutEventEmitter, getBrandName, ConfiguratorHandler } from '@pes-ui/utils';
import { isEqual } from 'lodash';
import { getDownloadButtonIcon, getDownloadButtonLabel, } from '../../../globals/software-documents/utils';
import { getCustomPrice, getIsCustomPriceEnabled } from '../../pes-router/utils';
import { getLocaleCodes } from '../../../globals/utils/helpers';
export class CtaAreaContainer {
  constructor() {
    var _a;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.dispatchUcoAddToCart = (quantity) => {
      const brand = getBrandName();
      const checkoutPayload = {
        country: this.checkoutEasyPayload.country,
        locale: this.checkoutEasyPayload.locale,
        products: [
          {
            applicationSource: brand,
            partType: "nonCto",
            productId: this.productId,
            quantity,
          },
        ],
      };
      CheckoutEventEmitter.dispatchCheckoutEvent(BUTTON_TYPES.ADD_TO_CART, checkoutPayload);
    };
    this.getProductFeedMinimalPriceText = () => {
      const product = this.getCurrentProductFeed();
      const price = findProductFeedMinimalPrice(product);
      const { countryLanguageCode, priceTemplate } = this.commerceConnectorSettings.options;
      if (!price || !countryLanguageCode || !priceTemplate) {
        return null;
      }
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.handleClick = (event) => {
      this.apcCtaButtonDidClick.emit({
        initialEvent: event,
        buttonType: this.getButtonType(),
        isStickyBar: this.isStickyBar,
      });
    };
    this.getButtonType = () => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[this.productId]) || null;
      if (availabilityType === EAvailabilityType.ADD_TO_CART
        || availabilityType === EAvailabilityType.PURCHASE_CD) {
        return EApcButtonType.ADD_TO_CART;
      }
    };
    this.getCtaButtonType = (primaryButtonsArray) => {
      let buttonType = this.findButtonType(primaryButtonsArray);
      const { enableProductSelectorButton } = this.selectorConfig || {};
      if (enableProductSelectorButton
        && !!this.selectorConfig
        && (primaryButtonsArray.indexOf(buttonType)
          > primaryButtonsArray.indexOf("PRODUCT_SELECTOR_BUTTON")
          || primaryButtonsArray.indexOf(buttonType) === -1)) {
        buttonType = "PRODUCT_SELECTOR_BUTTON";
      }
      return buttonType;
    };
    this.getPrices = () => {
      var _a, _b, _c;
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = (_c = (_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[this.productId]) !== null && _c !== void 0 ? _c : {};
      return {
        priceLabel: priceLabel || null,
        previousPriceValue: previousPriceValue || null,
        VATInclused: VATInclused || null,
        previousPrice: previousPrice || null,
        activePrice: activePrice || null,
        activePriceNoTax: activePriceNoTax || null,
        activePriceValue: activePriceValue || null,
      };
    };
    this.handleCtaClick = (cta) => {
      switch (cta) {
        case BUTTON_TYPES.ADD_TO_CART:
        case BUTTON_TYPES.ADD_TO_MYLIST:
          CheckoutEventEmitter.dispatchCheckoutEvent(cta, this.checkoutEasyPayload);
          break;
        case BUTTON_TYPES.SEE_SOFTWARE:
        case BUTTON_TYPES.VIEW_ONLINE_SOFTWARE:
        case BUTTON_TYPES.DOWNLOAD_SOFTWARE:
          this.downloadButtonDidClick.emit();
          break;
        default:
          break;
      }
    };
    this.marketPlacePdpUrl = '';
    this.productId = undefined;
    this.commerceConnectorSettings = undefined;
    this.productsFeed = undefined;
    this.currentProductFeed = undefined;
    this.apcCta = undefined;
    this.ctaData = undefined;
    this.addToMyProductsLabel = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.compareLabel = undefined;
    this.downloadLabel = undefined;
    this.showBuyOnline = undefined;
    this.isStickyBar = undefined;
    this.materialPriceGroup = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.showCompare = undefined;
    this.showFavorites = false;
    this.showSkeleton = false;
    this.isInMyProductsList = false;
    this.availabilityInfo = undefined;
    this.isApc = undefined;
    this.isInFavorites = false;
    this.selectorConfig = undefined;
    this.showProductSelectorStatus = undefined;
    this.circularEconomyInfo = undefined;
    this.prioritizeBuyNowButton = undefined;
    this.countryCode = undefined;
    this.localeCode = undefined;
    this.shoppableRedirectionData = undefined;
    this.productCR = undefined;
    this.shopSeLink = undefined;
    this.showShopSeLoader = undefined;
    this.stockQuantityLabel = undefined;
    this.isCircularProduct = undefined;
    this.softwareDocuments = undefined;
    this.isPBS = false;
    this.labels = undefined;
    this.addToCartButtonRendered = false;
    this.ctaInfo = undefined;
    this.showCtas = undefined;
    this.checkoutEasyPayload = null;
    this.handleCtaClick = this.handleCtaClick.bind(this);
  }
  componentWillRender() {
    if (!this.isUnifiedCheckoutEnabled)
      return;
    this.updateCtaInfoState();
    this.updateCheckoutEasyPayload();
  }
  updateCtaInfoState() {
    var _a, _b, _c, _d;
    const newCtaInfo = (_c = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.ctas) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : {};
    const newShowCtas = Array.isArray(newCtaInfo)
      ? Boolean(newCtaInfo === null || newCtaInfo === void 0 ? void 0 : newCtaInfo.length)
      : Boolean((_d = Object.keys(newCtaInfo)) === null || _d === void 0 ? void 0 : _d.length);
    if (!isEqual(this.ctaInfo, newCtaInfo)
      || this.showCtas !== newShowCtas) {
      this.ctaInfo = newCtaInfo;
      this.showCtas = newShowCtas;
    }
  }
  updateCheckoutEasyPayload() {
    if (!this.localeCode)
      return;
    const localeData = getLocaleCodes(this.localeCode);
    if (!(localeData === null || localeData === void 0 ? void 0 : localeData.countryCode) || !(localeData === null || localeData === void 0 ? void 0 : localeData.languageCode))
      return;
    const country = localeData.countryCode.toUpperCase();
    const locale = `${localeData.languageCode}_${country}`;
    const newPayload = {
      country,
      locale,
      productId: this.productId,
    };
    if (!this.checkoutEasyPayload
      || this.checkoutEasyPayload.country !== newPayload.country
      || this.checkoutEasyPayload.locale !== newPayload.locale
      || this.checkoutEasyPayload.productId !== newPayload.productId) {
      this.checkoutEasyPayload = newPayload;
    }
  }
  handleUcoAddToCartDidSubmit(e) {
    this.dispatchUcoAddToCart(e.detail);
  }
  getPriceTextContent() {
    if (getIsCustomPriceEnabled() && !!getCustomPrice()) {
      return this.getCustomPriceText(getCustomPrice());
    }
    if (this.showPartnerPrice()) {
      return this.getProductFeedMinimalPriceText();
    }
    return this.getProductPriceText();
  }
  showPartnerPrice() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  isPriceAvailable() {
    var _a, _b;
    return !!(((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.price) && ((_b = this.ctaData) === null || _b === void 0 ? void 0 : _b.currency));
  }
  getProductPriceText() {
    return this.isPriceAvailable() ? `${this.ctaData.price}&nbsp;${this.ctaData.currency}` : null;
  }
  getCustomPriceText(customPrice) {
    return `${customPrice.price}&nbsp;${customPrice.currencyCode}`;
  }
  getCurrentProductFeed() {
    var _a;
    return (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => (product === null || product === void 0 ? void 0 : product.ProductId) === this.productId);
  }
  hasTooltip() {
    var _a;
    return !this.showPartnerPrice() && !isEmpty((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.weeePrices);
  }
  renderWeeePrices() {
    if (!this.hasTooltip()) {
      return null;
    }
    return weeePricesToTextArray(this.ctaData.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  findButtonType(buttonTypes) {
    return buttonTypes.find((type) => { var _a; return type in (((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) || {}); });
  }
  renderSeButtonFactory(type, isSticky) {
    var _a, _b;
    const button = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[type];
    if (!button) {
      if (type === "PRODUCT_SELECTOR_BUTTON") {
        return this.renderProductSelectorButton("PRODUCT_SELECTOR_BUTTON");
      }
      return null;
    }
    switch (type) {
      case "BUY_ONLINE_BUTTON_REGULAR":
      case "BUY_ONLINE_BUTTON_APC":
        return this.renderBuyOnlineButton();
      case "BUY_MARKETPLACE_BUTTON_REGULAR":
        return this.getMarketPlaceButtonProps(button);
      case "NOTIFY_ME_BUTTON":
        return this.renderNotifyMeButton(button);
      case "ADD_TO_CART_BUTTON":
        return this.renderAddToCartButton(button, isSticky);
      case "DOWNLOAD_BUTTON":
        return this.renderDownloadButton(button);
      case "PROMOTED_BUTTON":
        return this.renderPromotedButton(button);
      default:
        return null;
    }
  }
  renderBuyOnlineButton() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (this.isCircularProduct
      && !((_b = (_a = this.currentProductFeed) === null || _a === void 0 ? void 0 : _a.RetailerProducts) === null || _b === void 0 ? void 0 : _b.length)) {
      return null;
    }
    let buttonProps = {};
    const regularButton = (_e = (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d.BUY_MARKETPLACE_BUTTON_REGULAR) !== null && _e !== void 0 ? _e : (_g = (_f = this.ctaData) === null || _f === void 0 ? void 0 : _f.buttons) === null || _g === void 0 ? void 0 : _g.BUY_ONLINE_BUTTON_REGULAR;
    const apcButton = (_j = (_h = this.ctaData) === null || _h === void 0 ? void 0 : _h.buttons) === null || _j === void 0 ? void 0 : _j.BUY_ONLINE_BUTTON_APC;
    buttonProps = this.buildBuyOnlineButton(buttonProps, regularButton, apcButton);
    if (buttonProps.label) {
      buttonProps.onClick = () => {
        if (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.link) {
          send(exitToSchneiderEvent, { link_url: buttonProps.link });
          this.buyOnlineClick.emit(buttonProps.link);
        }
        else
          this.buyOnlineClick.emit();
      };
    }
    return isEmpty(buttonProps) ? null : buttonProps;
  }
  buildBuyOnlineButton(buttonProps, regularButton, apcButton) {
    const buyOnlineButtonProps = Object.assign({}, buttonProps);
    if (regularButton && this.showBuyOnline) {
      if (regularButton.type === "BUY_MARKETPLACE_BUTTON_REGULAR") {
        buyOnlineButtonProps.link = this.marketPlacePdpUrl;
      }
      buyOnlineButtonProps.label = regularButton.labels.defaultLabel;
      buyOnlineButtonProps.dataset = {
        autotestId: "BUY_ONLINE_BUTTON_REGULAR".toLowerCase(),
      };
    }
    else if (apcButton === null || apcButton === void 0 ? void 0 : apcButton.link) {
      buyOnlineButtonProps.label = apcButton.labels.defaultLabel;
      buyOnlineButtonProps.icon = "arrow-top-right-on-square";
      buyOnlineButtonProps.link = apcButton.link;
      buyOnlineButtonProps.dataset = {
        autotestId: "BUY_ONLINE_BUTTON_APC".toLowerCase(),
      };
    }
    return buyOnlineButtonProps;
  }
  renderAddToCartButton(button, isSticky) {
    this.addToCartButtonRendered = true;
    return {
      importance: EQdsButtonImportance.STANDARD,
      icon: "shopping-cart",
      label: button.labels.defaultLabel,
      onClick: (e) => {
        this.addToCartButtonDidClick.emit({ initialEvent: e, isStickyBar: isSticky });
      },
      dataset: {
        autotestId: "ADD_TO_CART_BUTTON".toLowerCase(),
      },
    };
  }
  getMarketPlaceButtonProps(button) {
    const { defaultLabel, badgeText } = button.labels || {};
    if (!defaultLabel)
      return null;
    const buttonInfo = Object.assign(Object.assign({}, button), { link: this.marketPlacePdpUrl });
    return {
      label: button.labels.defaultLabel,
      link: this.marketPlacePdpUrl,
      showTags: true,
      tagText: badgeText,
      onClick: () => this.marketplaceDidClick.emit(buttonInfo),
      dataset: {
        autotestId: "BUY_MARKETPLACE_BUTTON_REGULAR".toLowerCase(),
      },
    };
  }
  renderNotifyMeButton(button) {
    return {
      label: button.labels.defaultLabel,
      onClick: () => this.notifyButtonDidClick.emit(button.link),
      dataset: {
        autotestId: "NOTIFY_ME_BUTTON".toLowerCase(),
      },
    };
  }
  renderDownloadButton(button) {
    return {
      icon: getDownloadButtonIcon(this.softwareDocuments),
      label: getDownloadButtonLabel(this.softwareDocuments, button, this.downloadLabel),
      onClick: () => this.downloadButtonDidClick.emit(),
      dataset: {
        autotestId: "DOWNLOAD_BUTTON".toLowerCase(),
      },
    };
  }
  renderPrimaryButton(isSticky) {
    const buttonType = this.getCtaButtonType(PRIMARY_BUTTONS);
    return this.renderSeButtonFactory(buttonType, isSticky);
  }
  renderSecondaryButton(isSticky) {
    let buttonType;
    const { enableProductSelectorButton } = this.selectorConfig || {};
    const primaryBtnType = this.getCtaButtonType(PRIMARY_BUTTONS);
    if (enableProductSelectorButton && primaryBtnType === "NOTIFY_ME_BUTTON") {
      buttonType = "PRODUCT_SELECTOR_BUTTON";
    }
    else {
      buttonType = this.findButtonType(SECONDARY_BUTTONS);
    }
    return this.renderSeButtonFactory(buttonType, isSticky);
  }
  renderPromotedButton(button) {
    var _a;
    return {
      label: (_a = button === null || button === void 0 ? void 0 : button.labels) === null || _a === void 0 ? void 0 : _a.defaultLabel,
      onClick: () => this.promotedButtonDidClick.emit(button === null || button === void 0 ? void 0 : button.link),
      dataset: {
        autotestId: "PROMOTED_BUTTON".toLowerCase(),
      },
    };
  }
  renderProductSelectorButton(buttonType) {
    var _a, _b;
    if (buttonType === "PRODUCT_SELECTOR_BUTTON"
      && ((_a = this.showProductSelectorStatus) === null || _a === void 0 ? void 0 : _a.state) === false) {
      return null;
    }
    return {
      label: (_b = this.selectorConfig) === null || _b === void 0 ? void 0 : _b.buttonlabel,
      onClick: () => { },
      icon: "squares-checked",
      dataset: {
        autotestId: buttonType.toLowerCase(),
      },
    };
  }
  addPromotedBtn(primary, secondary, promoted) {
    let emphasized = Object.assign({}, primary);
    let standard = [...secondary];
    if (!emphasized && !standard[0]) {
      emphasized = promoted;
    }
    else {
      standard.push(promoted);
    }
    standard = standard.filter((item) => !isNil(item)).length ? standard : null;
    return { emphasized, standard };
  }
  mapCtaButtons(isSticky = false) {
    const initialPrimaryBtn = this.renderPrimaryButton(isSticky);
    let secondaryBtn = [this.renderSecondaryButton(isSticky)];
    const promotedBtn = this.renderSeButtonFactory("PROMOTED_BUTTON", isSticky);
    const primaryBtn = initialPrimaryBtn || secondaryBtn[0];
    secondaryBtn = !initialPrimaryBtn ? [null] : secondaryBtn;
    const { emphasized, standard } = this.addPromotedBtn(primaryBtn, secondaryBtn, promotedBtn);
    return omitBy({
      emphasized,
      standard,
    }, isNil);
  }
  getPriceFromLabel() {
    var _a, _b;
    return this.showPartnerPrice() ? (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.priceFrom : null;
  }
  isFavoritesAllowed(isSticky = false) {
    if (this.isApc || !isSticky) {
      return this.showFavorites;
    }
    return this.showFavorites && !this.addToCartButtonRendered;
  }
  buildEApcAddToCartButton(buttonType) {
    var _a, _b;
    const button = {};
    if (buttonType === EApcButtonType.ADD_TO_CART) {
      button.label = (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel;
      button.icon = "shopping-cart";
      button.dataset = {
        autotestId: EApcButtonType.ADD_TO_CART.toLowerCase(),
      };
    }
    button.onClick = (e) => this.handleClick(e);
    return button.label ? button : null;
  }
  buildECtaApcButton(ctaButtonType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let button = {};
    let notifyButton;
    let downloadButton;
    let promotedButton;
    let productSelectorButton;
    let marketPlaceButton;
    switch (ctaButtonType) {
      case "NOTIFY_ME_BUTTON":
        notifyButton = this.renderNotifyMeButton((_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b["NOTIFY_ME_BUTTON"]);
        button = Object.assign(Object.assign({}, button), notifyButton);
        break;
      case "BUY_ONLINE_BUTTON_REGULAR":
        this.buildBuyOnlineButton(button, (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d["BUY_ONLINE_BUTTON_REGULAR"], {});
        button.importance = EQdsButtonImportance.STANDARD;
        button.onClick = () => this.buyOnlineClick.emit();
        break;
      case "BUY_MARKETPLACE_BUTTON_REGULAR":
        marketPlaceButton = this.getMarketPlaceButtonProps((_f = (_e = this.ctaData) === null || _e === void 0 ? void 0 : _e.buttons) === null || _f === void 0 ? void 0 : _f["BUY_MARKETPLACE_BUTTON_REGULAR"]);
        button = Object.assign(Object.assign({}, button), marketPlaceButton);
        break;
      case "DOWNLOAD_BUTTON":
        downloadButton = this.renderDownloadButton((_h = (_g = this.ctaData) === null || _g === void 0 ? void 0 : _g.buttons) === null || _h === void 0 ? void 0 : _h["DOWNLOAD_BUTTON"]);
        button = Object.assign(Object.assign({}, button), downloadButton);
        break;
      case "PROMOTED_BUTTON":
        promotedButton = this.renderPromotedButton((_k = (_j = this.ctaData) === null || _j === void 0 ? void 0 : _j.buttons) === null || _k === void 0 ? void 0 : _k["PROMOTED_BUTTON"]);
        button = Object.assign(Object.assign({}, button), promotedButton);
        break;
      case "PRODUCT_SELECTOR_BUTTON":
        productSelectorButton = this.renderProductSelectorButton("PRODUCT_SELECTOR_BUTTON");
        button = Object.assign(Object.assign({}, button), productSelectorButton);
        break;
      default:
        break;
    }
    return button.label ? button : null;
  }
  renderApcButton() {
    const buttonType = this.getButtonType();
    const ctaButtonType = this.getCtaButtonType(APC_PRIMARY_BUTTONS);
    const eComAddToCartBtn = this.buildEApcAddToCartButton(buttonType);
    const eCtaBtn = this.buildECtaApcButton(ctaButtonType);
    let secondaryProductSelectorBtn;
    const { enableProductSelectorButton } = this.selectorConfig || {};
    if (enableProductSelectorButton && ctaButtonType === "NOTIFY_ME_BUTTON") {
      secondaryProductSelectorBtn = this.buildECtaApcButton("PRODUCT_SELECTOR_BUTTON");
    }
    const primaryBtn = isNull(eComAddToCartBtn) && !isNull(eCtaBtn) ? eCtaBtn : eComAddToCartBtn;
    const secondaryBtn = [
      (!isNull(eComAddToCartBtn) && !isNull(eCtaBtn) && eCtaBtn.importance === EQdsButtonImportance.STANDARD)
        || isNull(secondaryProductSelectorBtn)
        ? eCtaBtn
        : secondaryProductSelectorBtn,
    ];
    const promotedBtn = this.buildECtaApcButton("PROMOTED_BUTTON");
    const { emphasized, standard } = this.addPromotedBtn(primaryBtn, secondaryBtn, promotedBtn);
    return omitBy({
      emphasized,
      standard,
    }, isNil);
  }
  renderStickyCtaArea(buttonsForSticky, priceHTML, priceFromLabel, isInFavorites, productSelectorInfo) {
    return (h("pes-cta-area-view-sticky", { imageUrl: this.imageUrl, imageTitle: this.imageTitle, priceHTML: priceHTML, tooltipHTML: this.renderWeeePrices(), buttons: buttonsForSticky, priceFromLabel: priceFromLabel, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(true), isInFavorites: isInFavorites, selectorConfig: this.selectorConfig, showProductSelectorStatus: this.showProductSelectorStatus, ctaInfo: this.ctaInfo, showCtas: this.showCtas, handleCtaClick: this.handleCtaClick, productSelectorInfo: productSelectorInfo }));
  }
  get secondaryPrice() {
    if (getIsCustomPriceEnabled() && !!getCustomPrice()) {
      if (this.showPartnerPrice()) {
        return this.getProductFeedMinimalPriceText();
      }
      return this.getProductPriceText();
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let buttons;
    let buttonsForSticky;
    let prices;
    let previousPriceHTML;
    let inStockLabel;
    let vatLabel;
    let resellerLabel;
    let priceHTML;
    let materialPriceGroup;
    let priceFromLabel;
    let showCompare;
    let isInFavorites;
    const addToCartType = EAvailabilityType.ADD_TO_CART;
    if (this.isApc) {
      prices = this.getPrices();
      priceHTML = prices.activePrice;
      buttons = this.renderApcButton();
      buttonsForSticky = this.renderApcButton();
      previousPriceHTML = prices.previousPrice;
      inStockLabel = ((_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.availability[this.productId]) === addToCartType
        ? (_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.inStockLabel
        : '';
      vatLabel = (prices === null || prices === void 0 ? void 0 : prices.VATInclused) && ((_e = (_d = this.apcCta) === null || _d === void 0 ? void 0 : _d.labels) === null || _e === void 0 ? void 0 : _e.vatLabel);
      resellerLabel = prices.priceLabel;
      isInFavorites = this.isInFavorites;
      showCompare = this.showCompare;
    }
    else {
      priceHTML = this.getPriceTextContent();
      buttons = this.mapCtaButtons();
      buttonsForSticky = this.mapCtaButtons(true);
      materialPriceGroup = this.materialPriceGroup;
      priceFromLabel = this.getPriceFromLabel();
      showCompare = this.showCompare;
      isInFavorites = this.isInMyProductsList;
    }
    const productSelectorInfo = {
      selectorConfig: this.selectorConfig,
      isCtaArea: true,
      buttonProps: this.renderProductSelectorButton("PRODUCT_SELECTOR_BUTTON"),
      showProductSelectorStatus: this.showProductSelectorStatus,
      addToMyCartLabel: (_f = this.labels) === null || _f === void 0 ? void 0 : _f.addToMyCart,
      addToMyListLabel: (_g = this.labels) === null || _g === void 0 ? void 0 : _g.addToMyList,
    };
    if (this.isStickyBar) {
      return this.renderStickyCtaArea(buttonsForSticky, priceHTML, priceFromLabel, isInFavorites, productSelectorInfo);
    }
    return (h(Host, null, h("pes-cta-area-view", { productId: this.productId, priceHTML: priceHTML, secondaryPrice: this.secondaryPrice, tooltipHTML: this.renderWeeePrices(), previousPriceHTML: previousPriceHTML, inStockLabel: inStockLabel, vatLabel: vatLabel, resellerLabel: resellerLabel, buttons: buttons, showSkeleton: this.showSkeleton, materialPriceGroup: materialPriceGroup, priceFromLabel: priceFromLabel, compareLabel: this.compareLabel, addedToCartLabel: (_k = (_j = (_h = this.ctaData) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.addedToCart) !== null && _k !== void 0 ? _k : null, showAddedToCartLabel: this.addToCartButtonRendered && this.isInMyProductsList, isInFavorites: isInFavorites, showCompare: showCompare, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(), selectorConfig: this.selectorConfig, showProductSelectorStatus: this.showProductSelectorStatus, circularEconomyInfo: this.circularEconomyInfo, prioritizeBuyNowButton: this.prioritizeBuyNowButton, countryCode: this.countryCode, localeCode: this.localeCode, isPBS: this.isPBS, shoppableRedirectionData: this.shoppableRedirectionData, productCR: this.productCR, shopSeLink: this.shopSeLink, showShopSeLoader: this.showShopSeLoader, stockQuantityLabel: this.stockQuantityLabel, ctaInfo: this.ctaInfo, showCtas: this.showCtas, handleCtaClick: this.handleCtaClick, productSelectorInfo: productSelectorInfo }, h("slot", { name: "discounted-price", slot: "discounted-price" }))));
  }
  static get is() { return "pes-cta-area-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["cta-area-container.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["cta-area-container.css"]
    };
  }
  static get properties() {
    return {
      "marketPlacePdpUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "market-place-pdp-url",
        "reflect": false,
        "defaultValue": "''"
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CommerceConnectorSettings",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productsFeed": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsFeed",
          "resolved": "FeedProduct[]",
          "references": {
            "ProductsFeed": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "currentProductFeed": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "FeedProduct",
          "resolved": "{ RetailerProducts: RetailerProduct[]; Id: string; ProductId: string; Brand: string; ManufacturerId: string; ManufacturerName: string; ManufacturerImages: ManufacturerImages[]; ProductName: string; ProductDescription: string; ProductUrl: string; MainImageUrl: string; MainImageAltText: string; LocalizedDescriptions: LocalizedDescription[]; ProductIdentifiers: string[]; Categories: []; MetaData?: string; }",
          "references": {
            "FeedProduct": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCtaData",
          "resolved": "{ currency?: string; price?: string; weeePrices?: WEEEPrices; buttons?: Partial<Record<ECtaButtonTypes, TCtaButton>>; labels?: { addedToCart: string; availableOnAPC?: string; }; ctas?: TCtaInfo[]; }",
          "references": {
            "TCtaData": {
              "location": "import",
              "path": "../product-main/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "addToMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-products-label",
        "reflect": false
      },
      "removeFromMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-from-my-products-label",
        "reflect": false
      },
      "compareLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-label",
        "reflect": false
      },
      "downloadLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "download-label",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-buy-online",
        "reflect": false
      },
      "isStickyBar": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-sticky-bar",
        "reflect": false
      },
      "materialPriceGroup": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TMaterialPriceGroup",
          "resolved": "{ price: string; label: string; }",
          "references": {
            "TMaterialPriceGroup": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "imageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image-url",
        "reflect": false
      },
      "imageTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image-title",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false
      },
      "showFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "showSkeleton": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-skeleton",
        "reflect": false,
        "defaultValue": "false"
      },
      "isInMyProductsList": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-my-products-list",
        "reflect": false,
        "defaultValue": "false"
      },
      "availabilityInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isApc": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-apc",
        "reflect": false
      },
      "isInFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScHpcProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; }",
          "references": {
            "TScHpcProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showProductSelectorStatus": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductSelectorStatus",
          "resolved": "{ loaded: boolean; isExternalState: boolean; state: boolean; }",
          "references": {
            "TProductSelectorStatus": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "circularEconomyInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularEconomy",
          "resolved": "{ circularCertifiedLogo?: string; message?: string; apiEndPointUrl?: string; toolTipMessage?: string; toolTipLearnMoreLabel?: string; toolTipLearnMoreUrl?: string; apiKey?: string; enableCircularProducts?: boolean; enableCircularProductNewBadge?: boolean; }",
          "references": {
            "CircularEconomy": {
              "location": "import",
              "path": "../../circular-economy/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "prioritizeBuyNowButton": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "prioritize-buy-now-button",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "shoppableRedirectionData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TShopableRedirectionCtaData",
          "resolved": "{ shoppableRedirectionLabel: string; shoppableBuyButtonLabel: string; link: { shopableRedirectionHostUrl: string; shoppableRedirectionClickableLabel: string; }; }",
          "references": {
            "TShopableRedirectionCtaData": {
              "location": "import",
              "path": "../product-main/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productCR": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-c-r",
        "reflect": false
      },
      "shopSeLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "shop-se-link",
        "reflect": false
      },
      "showShopSeLoader": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-shop-se-loader",
        "reflect": false
      },
      "stockQuantityLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "stock-quantity-label",
        "reflect": false
      },
      "isCircularProduct": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-circular-product",
        "reflect": false
      },
      "softwareDocuments": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductSoftwareDocument[]",
          "resolved": "TProductSoftwareDocument[]",
          "references": {
            "TProductSoftwareDocument": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "For determining label of DOWNLOAD_BUTTON"
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "addToCartButtonRendered": {},
      "ctaInfo": {},
      "showCtas": {},
      "checkoutEasyPayload": {}
    };
  }
  static get events() {
    return [{
        "method": "buyOnlineClick",
        "name": "buyOnlineClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string | undefined",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "notifyButtonDidClick",
        "name": "notifyButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "promotedButtonDidClick",
        "name": "promotedButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "downloadButtonDidClick",
        "name": "downloadButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "addToCartButtonDidClick",
        "name": "addToCartButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TAddToCartButtonEvent",
          "resolved": "{ initialEvent: MouseEvent; isStickyBar?: boolean; }",
          "references": {
            "TAddToCartButtonEvent": {
              "location": "import",
              "path": "./types"
            }
          }
        }
      }, {
        "method": "marketplaceDidClick",
        "name": "marketplaceDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TCtaButton",
          "resolved": "{ link?: string; labels: { defaultLabel: string; badgeText?: string; } & Record<string, string>; name?: string; category?: string; gaAttributes?: { product: string; type: string; }; }",
          "references": {
            "TCtaButton": {
              "location": "import",
              "path": "../types"
            }
          }
        }
      }, {
        "method": "apcCtaButtonDidClick",
        "name": "apcCtaButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TApcCtaButtonEvent",
          "resolved": "{ initialEvent: MouseEvent; buttonType: EApcButtonType; isStickyBar: boolean; link?: string; }",
          "references": {
            "TApcCtaButtonEvent": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "ucoAddToCartDidSubmit",
        "method": "handleUcoAddToCartDidSubmit",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
